module.exports = __webpack_public_path__ + "img/invite-success-136px.1a82897.png";